import React, {FunctionComponent, useCallback} from "react";
import {
    DemoRequestBottomCard, DemoRequestCard, TopCard,
    MiddleCard, DemoRequestBottomCardProps, OpenSiteModalType
} from "@klear/open-site";
import {OpenSiteMiddleCard, OpenSiteTopCard} from "../../interfaces/strapi";

const styles = require("./openPageCardsContainer.component.scss");

interface OpenPageCardsContainerProps {
    showDemoRequestCard: boolean;
    horizontalTopCard: boolean;
    topCard: OpenSiteTopCard;
    middleCards: OpenSiteMiddleCard[];
    ctaText?: string;
    modalType: OpenSiteModalType;
    demoRequestBottomCard: DemoRequestBottomCardProps;
}

export const OpenPageCardsContainer: FunctionComponent<OpenPageCardsContainerProps> = props => {
    const {showDemoRequestCard, horizontalTopCard, topCard, middleCards, ctaText, modalType,
        demoRequestBottomCard, children} = props;

    const getIsReverseDirection = useCallback((isHorizontal, index) => {
        return isHorizontal ? !(index % 2) : !!(index % 2);
    }, []);

    return (
        <>
            <div className={styles.container}>
                    <div className={styles.topCard}>
                        <TopCard {...topCard} ctaText={ctaText} modalType={modalType} horizontalTopCard={horizontalTopCard} />
                    </div>
                    {showDemoRequestCard &&
                        <DemoRequestCard title={'Ready to see it live?'} subtitle={'We\'ll be happy to show you around'}
                                         ctaText={'Demo'} modalType={modalType}/>}
                    {middleCards.map((card, index) =>
                        <MiddleCard key={index} {...card} ctaText={ctaText} modalType={modalType} reverseDirection={getIsReverseDirection(horizontalTopCard, index)} />
                    )}
                    {children}
                    <DemoRequestBottomCard {...demoRequestBottomCard} modalType={modalType} />
                </div>
        </>
    );
};